export const ACTION_CODE = 'OFFICE_ACTION';